import React, { Component } from 'react';

class Reset extends Component
{
    render() {
        return (
            <div className={'form-group align-right mb-0'}>
                <button aria-label='Filter Zurücksetzen' onClick={()=>this.props.resetFilter()} className={'btn btn-success'}>Zurücksetzen</button>
            </div>
        )
    }
}

export default Reset


// WEBPACK FOOTER //
// ./src/components/Reset.js